import { useMemo } from 'react';

import { SummaryStatsGroup } from '../../components';
import { useQSetSimilarityResult } from '../../providers';
import type { CheckType } from '../../types';

function totalQSetPairs(draftCount: number, publishedCount: number): Record<CheckType, number> {
  return {
    DRAFT_TO_DRAFT: draftCount,
    DRAFT_TO_PUBLISHED: draftCount + publishedCount,
    PUBLISHED_TO_PUBLISHED: publishedCount,
  };
}

export default function QSetSimilaritySummaryStats() {
  const { similarityResult, uniqueQSetCodes, type } = useQSetSimilarityResult();

  const { duplicationRate, data } = similarityResult;

  const draftCount = uniqueQSetCodes.drafts.length;
  const publishedCount = uniqueQSetCodes.published.length;

  const total = useMemo(
    () => totalQSetPairs(draftCount, publishedCount)[type],
    [draftCount, publishedCount, type],
  );

  const totalQuestions = useMemo(() => data?.[0]?.totalQuestions ?? 0, [data]);

  const totalPassed = useMemo(() => {
    const matrix = similarityResult.matrix;
    const codes = uniqueQSetCodes.drafts.concat(uniqueQSetCodes.published);
    const passed = codes.filter((code) => {
      const row = matrix[code];
      return !Object.values(row).some((v) => v !== null && v > duplicationRate);
    }).length;
    return passed;
  }, [uniqueQSetCodes, similarityResult.matrix]);

  const results = useMemo(
    () => ({
      total,
      totalPassed,
    }),
    [total, totalPassed],
  );

  return (
    <SummaryStatsGroup
      totalQuestions={totalQuestions}
      results={results}
      duplicationRate={duplicationRate}
    />
  );
}
